import { getFileExtension, signatures } from '@/helpers';

export class ValidationService {
  public static isFileValid(file: any, callback: any) {
    const fileExtension = getFileExtension(file.name);
    const fileSignatures = signatures();
    const fileSignature = fileSignatures[fileExtension];

    if (fileSignature !== null && fileSignature !== undefined) {
      const slice = file.slice(fileSignature.offset, fileSignature.offset + fileSignature.sizet);
      const reader = new FileReader();

      reader.onloadend = () => {
        // eslint-disable-next-line no-var
        var buffer = reader.result,
          view = new DataView(buffer as any),
          signature;

        if (view.byteLength === 8) {
          signature = view.getUint32(0, false).toString(16) + view.getUint32(4, false).toString(16);
        } else {
          signature = view.getUint32(0, false).toString(16);
        }

        if (fileSignature.signature.includes(signature.toUpperCase())) {
          callback(true);
        } else {
          callback(false);
        }
      };

      reader.readAsArrayBuffer(slice);
    } else {
      callback(false);
    }
  }
}
